<template>
  <div class="col-12 col-lg-6">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-playback /></span>
          <span>{{ capitalize($t('names.playback', { n: 1 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content">
          <div class="row">
            <div
              v-show="props.isAdDurationSectionVisible"
              class="col-12"
              :class="props.isDemandOrganization ? 'col-sm-4' : 'col-sm-6'">
              <h4>{{ capitalize($t('names.adDuration', { n: 1 })) }}</h4>
              <span id="package_details_ad_duration">
                <span
                  v-if="!props.deal.isNGOrPreferredDeal && props.deal.adDurationOverridable"
                  class="text-muted">
                  {{ $t('messages.noRestrictions') }}
                </span>
                <span
                  v-else-if="
                    props.deal.isNGOrPreferredDeal &&
                    (props.deal.adDurationMin === null || props.deal.adDurationMin === 0)
                  "
                  class="text-muted">
                  {{ $t('messages.basedOnScreensAdDuration') }}
                </span>
                <span
                  v-else
                  class="text-muted">
                  {{ props.deal.adDurationDescription }}
                </span>
              </span>
              <input
                id="package_details_ad_duration_min_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.adDurationMin" />
              <input
                id="package_details_ad_duration_max_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.adDurationMax" />
              <input
                id="package_details_ad_duration_overridable_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.adDurationOverridable" />
            </div>

            <div
              v-if="!props.isNGExternalOrPreferredExternalDeal"
              class="col-12"
              :class="props.isDemandOrganization ? 'col-sm-4' : 'col-sm-6'">
              <h4>{{ capitalize($t('names.screenFrequencyCap', { n: 1 })) }}</h4>
              <span id="package_details_frequency_cap">
                <span
                  v-if="
                    (!props.deal.isPreferredOrNGInternalDeal && props.deal.minSecondsBetweenPlaysOverridable) ||
                    (props.deal.isPreferredOrNGInternalDeal &&
                      (props.deal.minSecondsBetweenPlaysMin === null || props.deal.minSecondsBetweenPlaysMin === 0))
                  "
                  class="text-muted">
                  {{ $t('messages.noRestrictions') }}
                </span>
                <template v-else>
                  <span
                    class="text-muted"
                    data-entity-type="frequency-cap-value">
                    {{ props.deal.minSecondsBetweenPlaysDescription }}
                  </span>
                  <span class="text-muted ml-1">{{ $t('names.second', { n: 2 }) }}</span>
                </template>
              </span>
              <input
                id="package_details_frequency_cap_min_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.minSecondsBetweenPlaysMin" />
              <input
                id="package_details_frequency_cap_max_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.minSecondsBetweenPlaysMax" />
              <input
                id="package_details_frequency_cap_overridable_value"
                aria-hidden="true"
                type="hidden"
                :value="props.deal.minSecondsBetweenPlaysOverridable" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize } from 'vue';

  import { IconColoredPlayback } from '@/common/icons/colored';
  import { Package } from '@/common/models';

  interface IDealDetailsPlayback {
    deal: Package;
    isDemandOrganization: boolean;
    isAdDurationSectionVisible: boolean;
    isNGExternalOrPreferredExternalDeal: boolean;
  }

  const props = defineProps<IDealDetailsPlayback>();
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
